export default "__VITE_ASSET__CVF$KNoM__"